import React, { useEffect, useRef, useState } from "react";
import Logo from "../imagens/logo.png";
import { useNavigate } from "react-router-dom";
import { abrirModalPlanos } from "./precos";

function Topo({ creditos, beginnerMode, onToggleBeginnerMode, onAbrirTutorial }) {
  const navigate = useNavigate();
  const tutorialBtnRef = useRef(null);
  const [tooltipPos, setTooltipPos] = useState(null);
  const [mostrarTooltip, setMostrarTooltip] = useState(false);

  // Mostra o tooltip "Você pode acessar o tutorial quando quiser clicando aqui"
  // uma única vez por sessão, alguns segundos após carregar a página.
  useEffect(() => {
    const jaViu = sessionStorage.getItem("tutorialTooltipVisto") === "1";
    if (jaViu) return;
    const t1 = setTimeout(() => {
      if (tutorialBtnRef.current) {
        const r = tutorialBtnRef.current.getBoundingClientRect();
        setTooltipPos({ top: r.bottom + 10, left: r.left + r.width / 2 });
        setMostrarTooltip(true);
      }
    }, 1500);
    const t2 = setTimeout(() => {
      setMostrarTooltip(false);
      sessionStorage.setItem("tutorialTooltipVisto", "1");
    }, 8000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  let user = null;
  try {
    const raw = sessionStorage.getItem("user");
    user = raw ? JSON.parse(raw) : null;
  } catch {
    user = null;
  }

  function sair() {
    sessionStorage.removeItem("user");
    navigate("/entrar");
  }

  function abrirTutorial() {
    setMostrarTooltip(false);
    sessionStorage.setItem("tutorialTooltipVisto", "1");
    if (onAbrirTutorial) onAbrirTutorial();
  }

  const iniciais = user?.nome
    ? user.nome
        .split(" ")
        .slice(0, 2)
        .map((p) => p[0])
        .join("")
        .toUpperCase()
    : "?";

  return (
    <header className="topo">
      <div className="topo-esquerda">
        <img src={Logo} alt="VídeoOferta" className="topo-logo" />
      </div>

      <div className="topo-direita">
        {/* Tutorial */}
        <button
          type="button"
          className="topo-dicas"
          ref={tutorialBtnRef}
          onClick={abrirTutorial}
          title="Assistir tutorial"
          aria-label="Assistir tutorial"
        >
          <i className="fa-solid fa-play-circle" aria-hidden="true"></i>
          <span>Tutorial</span>
        </button>
        {mostrarTooltip && tooltipPos && (
          <div
            className="topo-tooltip"
            role="tooltip"
            style={{
              position: "fixed",
              top: tooltipPos.top,
              left: tooltipPos.left,
              transform: "translateX(-50%)",
            }}
          >
            <div className="topo-tooltip__bubble">
              Você pode acessar o tutorial quando quiser clicando aqui
            </div>
            <div className="topo-tooltip__arrow"></div>
          </div>
        )}

        {/* Dicas (modo iniciante) */}
        <button
          type="button"
          className="topo-dicas"
          onClick={onToggleBeginnerMode}
          aria-pressed={Boolean(beginnerMode)}
          title={beginnerMode ? "Desativar dicas" : "Ativar dicas"}
        >
          <i className="fa-solid fa-circle-question" aria-hidden="true"></i>
          <span>Dicas</span>
          <span className={`topo-dicas-pill ${beginnerMode ? "on" : "off"}`}>
            {beginnerMode ? "ON" : "OFF"}
          </span>
        </button>

        {/* Créditos */}
        <button
          type="button"
          className="topo-creditos"
          onClick={abrirModalPlanos}
        >
          <i className="fa-solid fa-coins"></i>
          <span>{creditos > 0 ? `${creditos} créditos` : "Comprar créditos"}</span>
        </button>

        {/* Usuário */}
        <div className="topo-user">
          <div className="topo-avatar">{iniciais}</div>
          <span className="topo-nome">{user?.nome?.split(" ")[0]}</span>
        </div>

        {/* Sair */}
        <button className="topo-sair" onClick={sair} title="Sair da conta">
          <i className="fa-solid fa-right-from-bracket"></i>
        </button>
      </div>
    </header>
  );
}

export default Topo;
